export const sortGoogleKeywordData = (keywords_searches) => {
  return keywords_searches?.monthly_clicks
    ?.slice(0, 10)
    .map((el) => [el.word, el.monthly_clicks])
    .sort((a, b) => b[1] - a[1]);
};
